module.exports = __webpack_public_path__ + "static/img/yaoqing2.edf1229.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/yaoqing2.png
// module id = zfN1
// module chunks = 24